document.addEventListener('DOMContentLoaded', () => {
    const mainMenu = document.querySelector('.vn-menu');
    const items = document.querySelectorAll('.vn-menu__item.has-children');

    if ( mainMenu ) {
        items.forEach(item => {
            const link = item.querySelector('.vn-menu__link');

            link.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const isOpen = item.classList.contains('open');

                // Reset tout
                items.forEach(i => {
                    i.classList.remove('open');
                    const l = i.querySelector('.vn-menu__link');
                    if (l) l.classList.remove('active');
                });

                // Ouvrir + activer si fermé
                if (!isOpen) {
                    item.classList.add('open');
                    link.classList.add('active');
                }

                updateMenuState();
            });
        });

        // Click outside → reset
        document.addEventListener('click', () => {
            items.forEach(item => {
                item.classList.remove('open');
                const link = item.querySelector('.vn-menu__link');
                if (link) link.classList.remove('active');
            });

            updateMenuState();
        });

        function updateMenuState() {
            const hasOpen = document.querySelector('.vn-menu__item.open');

            if (hasOpen) {
                mainMenu.classList.add('submenu-open');
            } else {
                mainMenu.classList.remove('submenu-open');
            }
        }
    }
});